import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FixtureItem from './FixtureItem';

class FixturesList extends Component {
  render() {
    const sortFixtures = fixtures => {
      return _.sortBy(fixtures, [
        f => {
          return f.datetime;
        }
      ]);
    };

    const getCompetitions = fixtures => {
      const comps = _.uniqBy(sortFixtures(fixtures), f => f.competition._id);
      return comps.map(c => c.competition._id);
    };

    const groupedFixtures = fixtures => {
      return _.groupBy(sortFixtures(fixtures), obj => {
        return obj.competition._id;
      });
    };

    const groups = groupedFixtures(this.props.fixtures);
    const competitions = getCompetitions(this.props.fixtures);

    return (
      <div>
        {competitions.map(compKey => {
          return (
            <div className="fixture-container" key={compKey}>
              <h4 key={`${compKey}-title`}>{`${
                groups[compKey][0].competition.name
              } ${groups[compKey][0].competition.year}`}</h4>
              {groups[compKey].map(f => FixtureItem(f, this.props.clubId))}
            </div>
          );
        })}
      </div>
    );
  }
}

FixturesList.propTypes = {
  fixtures: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      datetime: PropTypes.string.isRequired,
      countryBoard: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      isResult: PropTypes.bool.isRequired,
      code: PropTypes.string.isRequired,
      gender: PropTypes.string.isRequired,
      home: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        img: PropTypes.string.isRequired
      }),
      away: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        img: PropTypes.string.isRequired
      }),
      competition: PropTypes.shape({
        _id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
      })
    })
  ).isRequired
};

export default FixturesList;



// WEBPACK FOOTER //
// ./src/components/Fixtures/FixturesList.js